<div *ngIf="isEncrypted" class="fixed inset-0 bg-black/60 flex items-center justify-center z-[70]">
  <div class="relative w-[90%] max-w-md bg-white rounded-2xl shadow-xl p-6 text-center animate-fade-in">
    <h2 class="text-xl font-bold text-gray-900 mb-4">Chat not available</h2>
    <p class="text-gray-600 mb-6">
      Please turn off encryption to use chat.
    </p>
  </div>
</div>
